export default <svg id="minus" xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44">
  <rect id="Rectangle_23" data-name="Rectangle 23" width="44" height="44" fill="none"/>
  <circle id="Ellipse_23" data-name="Ellipse 23" cx="16" cy="16" r="16" transform="translate(6 6)" fill="none" stroke="#e23734" strokeMiterlimit="10" strokeWidth="2"/>
  <line id="Line_7" data-name="Line 7" x2="14" transform="translate(15 22)" fill="none" stroke="#e23734" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
</svg>
